import React from "react";
import ProfileInput from "./ProfileInput";
import { Button } from "@material-tailwind/react";
import { useReduxStore } from "../hooks/useReduxStore";
import { useForm } from "react-hook-form";
import { EditBasicInfoAction } from "../store/Actions/action";
import Schemas from "../utilities/validations";
export default function BasicInfoComponent({ dark = false }) {
  const { getState } = useReduxStore();
  const {
    register,
    formState: { errors },
  } = useForm({
    resolver: Schemas.editBasicInfo,
  });

  const { userData } = getState("AUTH");
  const { name, email } = userData || {};
  return (
    <div className="flex flex-col gap-6">
      <ProfileInput
        disabled
        label={"Name"}
        defaultValue={name}
        placeholder="Enter Name"
        type="text"
        id="first_name"
        name={"name"}
        errors={errors}
        register={register}
        dark={dark}
      />
      <ProfileInput
        disabled
        label={"Email"}
        defaultValue={email}
        placeholder="Enter Email"
        type="email"
        id="email"
        name={"email"}
        errors={errors}
        register={register}
        dark={dark}
      />
    </div>
  );
}
